export default __webpack_public_path__ + "static/media/card-ornament.ac93e47c.svg";